import { useSelector } from 'react-redux';
import {useTranslation} from 'react-i18next';
import {useState} from 'react';
import {StyledAddComment} from './comments.styled';
import send from '../../images/newDesign/send.svg';

export default function AddComment({onEnter, withBorder, className}) {
    const {t} = useTranslation();
    const [text, setText] = useState('');

    const ltr = useSelector((state) => state.common.ltrEnabled);

    const handleKeyPress = (event) => {
        if(event.key === 'Enter') {
            onEnter(text);
            setText('');
        }
    };

    return (
        <StyledAddComment className={`${withBorder ? 'with-border' : ''} ${className}`} ltr={ltr}>
            <div className={'form-control-group'}>
                <input
                    type="text"
                    className={`form-control`}
                    placeholder={t('comments.add')}
                    value={text}
                    onInput={evt => setText(evt.target.value)}
                    onKeyPress={handleKeyPress}
                />
                <img
                    className={'send'}
                    src={send}
                    alt="send"
                    onClick={() => {
                        onEnter(text);
                        setText('');
                    }}
                />
            </div>
        </StyledAddComment>
    );
}